const RSVP_EXPERIMENT_NAME = 'test_rsvp_success_affil_roktv2';

export const isInRsvpSuccessAffilRoktControl = ({readOnly}: {readOnly: boolean}) =>
  evite.experiments.inVariation(RSVP_EXPERIMENT_NAME, 'control', true, readOnly);
